module.exports = {
  defaultLanguages: ['en'],
  supportedLanguages: ['en', 'de', 'es', 'pl'],
  keySeparator: false,
  namespaceSeparator: ':',
};
